module.exports = __webpack_public_path__ + "static/media/user-nft-17.cd18cbd3.jpg";